import * as React from 'react';
import IconBadge from 'src/IconBadge';
import {cn} from 'src/lib/utils';

type Props = {
  children: React.ReactNode;
  icon?: React.ReactNode;
  showIcon?: boolean;
  onSelect: () => void;
  selected: boolean;
};

const PickerRow = (props: Props) => {
  return (
    <div
      className={cn(
        'py-2 px-2 min-w-40 cursor-pointer',
        props.selected
          ? 'bg-primary text-primary-foreground'
          : 'hover:bg-accent',
      )}
      onClick={props.onSelect}
    >
      {props.showIcon ? (
        <IconBadge icon={props.icon}>{props.children}</IconBadge>
      ) : (
        props.children
      )}
    </div>
  );
};

export {PickerRow};
